import React from 'react'
import { observer } from "mobx-react";
import { onSnapshot } from "mobx-state-tree";
import { Col, Row } from "antd";

import { FSelect, Option } from "../common/form";
import { Siblings } from "../models/Book";

const idToTemplate = { // 兄弟の数と性別の組み合わせ
  "": "",
  "": 0, // 0人
  "0": 1, // 1人 男性
  "1": 2, // 1人 女性
  "00": 3, // 2人 男性 男性
  "10": 4, // 2人 男性 女性
  "11": 5, // 2人 女性 女性
};

const templateToId = {
  "": "",
  0: "0",
  1: "0",
  2: "1",
  3: "00",
  4: "10",
  5: "11",
};


const SiblingTemplate = observer(({ sibling, label }) => (
  <Row>
    <Col span={11}>
      <div className="label">{label}</div>
      <FSelect
        defaultValue={sibling.gender}
        onChange={v => sibling.changeGender(v)}
        size="large"
      >
        <Option value={0}>男性</Option>
        <Option value={1}>女性</Option>
      </FSelect>
    </Col>
  </Row>
));

class SiblingTemplateRender extends React.Component {
  constructor(props) {
    super(props);
    this.sibling = Siblings.create({});
    onSnapshot(this.sibling, this.onChange);
  }

  componentWillMount() {
    if (this.props.book.childToParent.siblingTemplate) {
      let ids = templateToId[this.props.book.childToParent.siblingTemplate].split('');
      ids.forEach((v, k) => this.sibling[`sibling${k + 1}`].setUpFromId(parseInt(v)));
    }
  }

  componentWillReceiveProps() {
    this.onChange();
  }

  onChange = () => {
    this.props.book.childToParent.changeSiblingTemplate(idToTemplate[this.sibling.id(this.props.book.childToParent.sibling)]);
  }

  render() {
    const { sibling } = this.props.book.childToParent;
    console.log(this.sibling);
    let ret = [];
    for (let i = 0; i < sibling; i++) {
      ret.push(
        <SiblingTemplate
          sibling={this.sibling[`sibling${i + 1}`]}
          key={i}
          label={sibling === 1 ? '兄弟・姉妹の性別' : `${i + 1}人目の兄弟・姉妹の性別`}
        />
      );
    }
    return ret;
  }
}

export default observer(SiblingTemplateRender);



// WEBPACK FOOTER //
// ./src/components/SiblingTemplateRender.js